import { render, staticRenderFns } from "./PromoInfo.vue?vue&type=template&id=1fe20b96"
import script from "./PromoInfo.vue?vue&type=script&lang=js"
export * from "./PromoInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports